import { Link } from "react-router-dom";
import { styled } from "styled-components";
import media from "../screenSizes";

export const BACKGROUND_COLOR = '#0E2A47';
export const OTHER_BACKGROUND_COLOR = '#3295dc';
export const SECONDARY_COLOR = '#fb4a59';
export const TEXT_COLOR = '#fcfaf7';
export const FOOTER_BACKGROUND_COLOR = '#436284'



export const StyledNavbarContainer = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  padding-left: 70px;
  padding-right: 70px;

  box-sizing: border-box;
  justify-content: space-evenly;
  align-items: center;

  ${() => media.mobile(`
    flex-direction: column-reverse;
    padding: 0;
    justify-content: space-between;
  `)}
    ${() => media.tablet(`
    flex-direction: column-reverse;
    padding: 0;
    justify-content: space-between;
  `)}

  ${() => media.laptop(`
    padding-left: 20px;
    padding-right: 20px;

  `)}
`

export const StyledNameContainer = styled(Link)`
  font-size: 35px;
  margin: 0;
  margin-bottom: 10px;
  display:block;
  text-decoration: none;
  color: ${TEXT_COLOR};

    ${() => media.mobile(`
    display: none;
  `)}
      ${() => media.tablet(`
    display: none;
  `)}
`

export const StyledEmailContainer = styled.a`
  font-size: 20px;
  color: ${TEXT_COLOR};
`

export const StyledTitleContainer = styled.div`
  flex: 1 0;

  ${() => media.mobile(`
    display: none;
  `)}
    ${() => media.tablet(`
    display: none;
  `)}
`

export const StyledGuitarContainer = styled(Link)`
  position: relative;
  height: 100%;
  flex: 1 0;
  cursor: auto;
`

export const StyledGuitar = styled.img`
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
  height: 65%;
  cursor: pointer;

  ${() => media.mobile(`
    height: auto;
    width: 140px;
  `)}
    ${() => media.tablet(`
    height: auto;
    width: 140px;
  `)}
`

export const StyledButtonGroup = styled.div`
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  flex: 1 0;
  align-items: center;
  ${() => media.mobile(`
    display: none;
  `)}
    ${() => media.tablet(`
    display: none;
  `)}
  ${() => media.laptop(`
    gap: 10px;
  `)}
`


export const StyledNavbarButton = styled(Link)`
  width: 125px;
  height: 65px;
  color: ${TEXT_COLOR};
  text-decoration: none;
  border-radius: 10px;
  position: relative;
  padding: 0;
  overflow: hidden;

  ${() => media.laptop(`
    width: 80px;
  `)}

    ${() => media.desktop(`
    width: 100px;
  `)}

`

export const StyledNavButtonText = styled.p`
display: block;
  margin: 0;
  text-align: center;
  font-size: 20px;
  font-weight: 100;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  ${() => media.desktop(`
    font-size: 18px;

  `)}

`

export const StyledHover = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${BACKGROUND_COLOR};
  z-index: 1;

  
  filter: brightness(${props => props.$hover ? '60%' : '85%'});

  transition: all 0.2s ease;

`

export const StyledDropdown = styled.div`
  position: absolute;
  top: ${props => props.$top + 'px' || 0};
  right: ${props => `calc(100vw - ${props.$right}px)`};
  margin-top: 10px;

  min-width: ${props => props.$width + 'px' || 0};
  width: 265px;
  z-index: 2;

  background-color: ${TEXT_COLOR};
  /* display: ${props => props.$show ? 'block' : 'none'}; */

  /* clip: ${props => `rect(${props.$top + 'px'}, calc(100vw - ${props.$right}px), ${props.$top + 'px'}, calc(${props.$right}px-265px))`}; */
  /* clip: ${props => `rect(1, 2, 3, 5)`}; */

  /* transform: scaleY(${props => props.$show ? '0' : '1'});
  transform-origin:top;
  transition: transform 0.3s ease; */

  max-height: ${props => props.$show ? 'none' : '0px'};
  transition: max-height 0.3s ease;



  border-radius: 10px;
  overflow: hidden;
  
`


export const StyledOption = styled.a`
  width: 100%;
  height: 50px;
  color: black;
  display: block;
  position: relative;
  cursor: pointer;
  background-color: ${props => props.$hovered ? '#fb4a597F' : 'transparent'};
  transition: background-color 0.1s ease;
`

export const StyledOptionLabel = styled.div`
  margin-left: 15px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`

export const StyledChildren = styled.div`
  width: 100%;
  height: 100%;
  z-index: 1;
`

export const StyledDownloadImg = styled.img`
  height: 18px;
  vertical-align: bottom;
  filter: invert(20%);
`

export const StyledPage = styled.div`
  width: 100vw;
  min-height: 90vh;
  /* background-color: ${BACKGROUND_COLOR}; */
  font-family: 'Doppio One', sans-serif;
  color: ${TEXT_COLOR};
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  z-index: 1;


/* width */
&::-webkit-scrollbar {
  width: 15px;
  ${() => media.mobile(`
    display: none;
  `)}
    ${() => media.tablet(`
    display: none;
  `)}
}

/* Track */
&::-webkit-scrollbar-track {
  background: #9ab8d7;
  box-shadow: inset 0 0 5px grey;
}

/* Handle */
&::-webkit-scrollbar-thumb {
  background: #5279a0;
}

background-color: #0e2a47;
background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 304 304' width='304' height='304'%3E%3Cpath fill='%232a8bee' fill-opacity='0.11' d='M44.1 224a5 5 0 1 1 0 2H0v-2h44.1zm160 48a5 5 0 1 1 0 2H82v-2h122.1zm57.8-46a5 5 0 1 1 0-2H304v2h-42.1zm0 16a5 5 0 1 1 0-2H304v2h-42.1zm6.2-114a5 5 0 1 1 0 2h-86.2a5 5 0 1 1 0-2h86.2zm-256-48a5 5 0 1 1 0 2H0v-2h12.1zm185.8 34a5 5 0 1 1 0-2h86.2a5 5 0 1 1 0 2h-86.2zM258 12.1a5 5 0 1 1-2 0V0h2v12.1zm-64 208a5 5 0 1 1-2 0v-54.2a5 5 0 1 1 2 0v54.2zm48-198.2V80h62v2h-64V21.9a5 5 0 1 1 2 0zm16 16V64h46v2h-48V37.9a5 5 0 1 1 2 0zm-128 96V208h16v12.1a5 5 0 1 1-2 0V210h-16v-76.1a5 5 0 1 1 2 0zm-5.9-21.9a5 5 0 1 1 0 2H114v48H85.9a5 5 0 1 1 0-2H112v-48h12.1zm-6.2 130a5 5 0 1 1 0-2H176v-74.1a5 5 0 1 1 2 0V242h-60.1zm-16-64a5 5 0 1 1 0-2H114v48h10.1a5 5 0 1 1 0 2H112v-48h-10.1zM66 284.1a5 5 0 1 1-2 0V274H50v30h-2v-32h18v12.1zM236.1 176a5 5 0 1 1 0 2H226v94h48v32h-2v-30h-48v-98h12.1zm25.8-30a5 5 0 1 1 0-2H274v44.1a5 5 0 1 1-2 0V146h-10.1zm-64 96a5 5 0 1 1 0-2H208v-80h16v-14h-42.1a5 5 0 1 1 0-2H226v18h-16v80h-12.1zm86.2-210a5 5 0 1 1 0 2H272V0h2v32h10.1zM98 101.9V146H53.9a5 5 0 1 1 0-2H96v-42.1a5 5 0 1 1 2 0zM53.9 34a5 5 0 1 1 0-2H80V0h2v34H53.9zm60.1 3.9V66H82v64H69.9a5 5 0 1 1 0-2H80V64h32V37.9a5 5 0 1 1 2 0zM101.9 82a5 5 0 1 1 0-2H128V37.9a5 5 0 1 1 2 0V82h-28.1zm16-64a5 5 0 1 1 0-2H146v44.1a5 5 0 1 1-2 0V18h-26.1zm102.2 270a5 5 0 1 1 0 2H98v14h-2v-16h124.1zM242 149.9V160h16v34h-16v62h48v48h-2v-46h-48v-66h16v-30h-16v-12.1a5 5 0 1 1 2 0zM53.9 18a5 5 0 1 1 0-2H64V2H48V0h18v18H53.9zm112 32a5 5 0 1 1 0-2H192V0h50v2h-48v48h-28.1zm-48-48a5 5 0 0 1-9.8-2h2.07a3 3 0 1 0 5.66 0H178v34h-18V21.9a5 5 0 1 1 2 0V32h14V2h-58.1zm0 96a5 5 0 1 1 0-2H137l32-32h39V21.9a5 5 0 1 1 2 0V66h-40.17l-32 32H117.9zm28.1 90.1a5 5 0 1 1-2 0v-76.51L175.59 80H224V21.9a5 5 0 1 1 2 0V82h-49.59L146 112.41v75.69zm16 32a5 5 0 1 1-2 0v-99.51L184.59 96H300.1a5 5 0 0 1 3.9-3.9v2.07a3 3 0 0 0 0 5.66v2.07a5 5 0 0 1-3.9-3.9H185.41L162 121.41v98.69zm-144-64a5 5 0 1 1-2 0v-3.51l48-48V48h32V0h2v50H66v55.41l-48 48v2.69zM50 53.9v43.51l-48 48V208h26.1a5 5 0 1 1 0 2H0v-65.41l48-48V53.9a5 5 0 1 1 2 0zm-16 16V89.41l-34 34v-2.82l32-32V69.9a5 5 0 1 1 2 0zM12.1 32a5 5 0 1 1 0 2H9.41L0 43.41V40.6L8.59 32h3.51zm265.8 18a5 5 0 1 1 0-2h18.69l7.41-7.41v2.82L297.41 50H277.9zm-16 160a5 5 0 1 1 0-2H288v-71.41l16-16v2.82l-14 14V210h-28.1zm-208 32a5 5 0 1 1 0-2H64v-22.59L40.59 194H21.9a5 5 0 1 1 0-2H41.41L66 216.59V242H53.9zm150.2 14a5 5 0 1 1 0 2H96v-56.6L56.6 162H37.9a5 5 0 1 1 0-2h19.5L98 200.6V256h106.1zm-150.2 2a5 5 0 1 1 0-2H80v-46.59L48.59 178H21.9a5 5 0 1 1 0-2H49.41L82 208.59V258H53.9zM34 39.8v1.61L9.41 66H0v-2h8.59L32 40.59V0h2v39.8zM2 300.1a5 5 0 0 1 3.9 3.9H3.83A3 3 0 0 0 0 302.17V256h18v48h-2v-46H2v42.1zM34 241v63h-2v-62H0v-2h34v1zM17 18H0v-2h16V0h2v18h-1zm273-2h14v2h-16V0h2v16zm-32 273v15h-2v-14h-14v14h-2v-16h18v1zM0 92.1A5.02 5.02 0 0 1 6 97a5 5 0 0 1-6 4.9v-2.07a3 3 0 1 0 0-5.66V92.1zM80 272h2v32h-2v-32zm37.9 32h-2.07a3 3 0 0 0-5.66 0h-2.07a5 5 0 0 1 9.8 0zM5.9 0A5.02 5.02 0 0 1 0 5.9V3.83A3 3 0 0 0 3.83 0H5.9zm294.2 0h2.07A3 3 0 0 0 304 3.83V5.9a5 5 0 0 1-3.9-5.9zm3.9 300.1v2.07a3 3 0 0 0-1.83 1.83h-2.07a5 5 0 0 1 3.9-3.9zM97 100a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-48 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 96a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-144a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-96 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm96 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-32 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM49 36a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-32 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM33 68a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 240a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm80-176a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm112 176a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17 180a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17 84a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'%3E%3C/path%3E%3C/svg%3E");


`